export const FIXTURE_SCOPES = [
  { id: "upcoming", label: "Upcoming" },
  { id: "past", label: "Past" },
  { id: "all", label: "All" },
];

export const LEAGUE_DESK_VIEWS = [
  { id: "managed", label: "Managed", hint: "Synced leagues" },
  { id: "candidates", label: "Candidates", hint: "Discovery pool" },
];

export const LEAGUE_STATUS_FILTERS = [
  { id: "all", label: "All leagues", hint: "Full catalog" },
  { id: "enabled", label: "Active", hint: "Enabled for sync" },
  { id: "disabled", label: "Inactive", hint: "Disabled leagues" },
];

export const SEASON_PHASE_FILTERS = [
  { id: "all", label: "All seasons", hint: "Any window" },
  { id: "in_season", label: "In season", hint: "Currently active" },
  { id: "no_upcoming", label: "No upcoming fixtures", hint: "Needs attention" },
  { id: "upcoming", label: "Not started", hint: "Future kickoff" },
  { id: "ended", label: "Season ended", hint: "Completed window" },
];

export const SEASON_PHASE_GROUPS = [
  { id: "in_season", label: "In season" },
  { id: "no_upcoming", label: "No upcoming fixtures" },
  { id: "upcoming", label: "Not started yet" },
  { id: "ended", label: "Season ended" },
  { id: "unknown", label: "No season dates" },
];

export const SEASON_PHASE_META = {
  in_season: { label: "In season", tag: "amf-row-tag-live" },
  no_upcoming: { label: "No upcoming", tag: "amf-row-tag-warn" },
  upcoming: { label: "Upcoming", tag: "amf-row-tag-warn" },
  ended: { label: "Ended", tag: "amf-row-tag-muted" },
  unknown: { label: "Unknown", tag: "amf-row-tag-muted" },
};
